export class EidEasy {
  static readonly signatureMethods = [
    'id-signature',
    'mid-signature',
    'lt-mid-signature',
    'spid-qes-signature',
    'smart-id-signature',
    'be-id-signature',
    'lt-id-signature',
    'lv-id-signature',
    'fi-id-signature',
    'hr-id-signature',
    'certeurope-usb-token-signature',
    'certsign-usb-token-signature',
    'at-handy-signatur-signature',
    'lv-eparaksts-mobile-signature',
    'evrotrust-signature',
    'd-trust-sign-me-qes-signature',
    'chave-movel-qes-signature',
    'simply-sign-qes-signature',
    'yes-com-qes-signature',
    'uanataca-qes-signature',
    'halcom-qes-signature',
    'certsign-webapi-qes-signature',
    'swiss-com-qes-signature',
    'dk-mitid-qes-signature',
    'se-bankid-qes-signature',
    'se-frejaeid-qes-signature',
  ];
}
